import { useState } from "react";
import { useIdioma, useT } from "../lib/i18n";

/** El tema vive en `<html data-theme>` (lo fija el script de index.html sin parpadeo). Aquí solo se
 *  voltea y se persiste; no hace falta estado global. */
function temaActual(): "claro" | "oscuro" {
  return typeof document !== "undefined" && document.documentElement.getAttribute("data-theme") === "light"
    ? "claro"
    : "oscuro";
}

const Sol = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4l1.4-1.4M18 6l1.4-1.4" />
  </svg>
);
const Luna = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M20 14.5A8 8 0 0 1 9.5 4a7 7 0 1 0 10.5 10.5z" />
  </svg>
);

/** Toggle de tema (claro/oscuro) + toggle de idioma (ES/EN), a la derecha de la barra. */
export function Controles() {
  const t = useT();
  const { idioma, setIdioma } = useIdioma();
  const [tema, setTema] = useState<"claro" | "oscuro">(temaActual);

  const voltearTema = () => {
    const nuevo = tema === "claro" ? "oscuro" : "claro";
    document.documentElement.setAttribute("data-theme", nuevo === "claro" ? "light" : "dark");
    try { localStorage.setItem("tema", nuevo); } catch { /* sin storage */ }
    setTema(nuevo);
  };

  const etiquetaTema = tema === "claro" ? t("Cambiar a tema oscuro") : t("Cambiar a tema claro");

  return (
    <div className="controles">
      <button className="ctrl" onClick={voltearTema} title={etiquetaTema} aria-label={etiquetaTema}>
        {tema === "claro" ? <Luna /> : <Sol />}
      </button>
      <button
        className="ctrl ctrl-idioma"
        onClick={() => setIdioma(idioma === "es" ? "en" : "es")}
        title={t("Idioma")}
        aria-label={idioma === "es" ? t("Inglés") : t("Español")}
      >
        {idioma === "es" ? "EN" : "ES"}
      </button>
    </div>
  );
}
